import {IGroup, IUser, QueryFilter} from "@/types/api.ts";
import ObjectChecker from "@/utils/ObjectChecker.ts";

export const API_BASE = import.meta.env.VITE_API_BASE;
console.log(import.meta.env, API_BASE)

export const API_URLS = {
  auth: {
    register: `${API_BASE}/auth/register`,
    login: `${API_BASE}/auth/login`,
    loginByCodeAndPassword: `${API_BASE}/auth/login-by-code-password`,
    logout: `${API_BASE}/auth/logout`,
    refresh: `${API_BASE}/auth/refresh-token`,
    me: `${API_BASE}/auth/me`,
    verifyEmail: `${API_BASE}/auth/verify-email`,
    forgotPassword: `${API_BASE}/auth/forgot-password`,
    resetPassword: `${API_BASE}/auth/reset-password`,
    changePassword: `${API_BASE}/auth/change-password`,
    googleLogin: `${API_BASE}/auth/google`,
    googleCallback: `${API_BASE}/auth/google/callback`,
    completeProfile: `${API_BASE}/auth/complete-profile`,
    update: `${API_BASE}/auth/me/update`,
  },

  users: {
    me: `${API_BASE}/users/me`,
    createStudent: `${API_BASE}/users/create-student`,
    getById: (id: string) => `${API_BASE}/users/${id}`,
    updateById: (id: string) => `${API_BASE}/users/${id}`,
  },

  admin: {
    getUsers: (query?: QueryFilter<IUser>) => `${API_BASE}/admin/users?${toURLSearchQueryParams(query)}`,
    dashboardOverview: `${API_BASE}/admin/dashboard-overview`,
    updateUsers: `${API_BASE}/admin/update-users`,
    generateNextId: `${API_BASE}/admin/generate-next-id`,
    forceUserToLogout: (userId: IUser['_id']) => `${API_BASE}/admin/${userId}/force-logout`
  },

  exams: {
    submit: `${API_BASE}/exams/submit-degree`,
    gradesForCurrentUser: `${API_BASE}/exams/grades/me`,
    deleteById: (id: string) => `${API_BASE}/exams/${id}`,
    gradesForAllStudents: `${API_BASE}/exams/grades/all`,
    getById: (id: string) => `${API_BASE}/exams/${id}`,
  },

  lessons: {
    list: `${API_BASE}/lessons`,
    create: `${API_BASE}/lessons/create-lesson`,
    getById: (id: string) => `${API_BASE}/lessons/${id}`,
    deleteById: (id: string) => `${API_BASE}/lessons/${id}`,
    deleteAttendanceFromLesson: (lessonId: string, attendanceId: string) => `${API_BASE}/lessons/${lessonId}/${attendanceId}`,
    addAttendance: (lessonId: string) => `${API_BASE}/lessons/${lessonId}/add-attendance`,
    viewStudentAttendance:`${API_BASE}/lessons/student-attendance`
  },
  payments: {
    list: `${API_BASE}/payments`,
    create: `${API_BASE}/payments`,
    getById: (id: string) => `${API_BASE}/payments/${id}`,
    updateMany: `${API_BASE}/payments`,
    deleteById: (id: string) => `${API_BASE}/payments/${id}`,
    getCurrentStudentPayments: `${API_BASE}/payments/students/me/payments`,
    getStudentPayments: (studentId: string) => `${API_BASE}/payments/students/${studentId}/payments`
  },
  groups: {
    list: (query?: QueryFilter<IGroup>) => `${API_BASE}/groups?${toURLSearchQueryParams(query)}`,
    create: `${API_BASE}/groups`,
    getById: (id: string) => `${API_BASE}/groups/${id}`,
    updateById: (id: string) => `${API_BASE}/groups/${id}`,
    deleteById: (id: string) => `${API_BASE}/groups/${id}`,
    joinStudents: (id: string) => `${API_BASE}/groups/${id}/join-students`
    // router.get("/", groupsController.getAll)
    // router.get("/:id", groupsController.getById)
    // router.post("/", groupsController.createNew)
    // router.put("/:id", groupsController.updateById)
    // router.delete("/:id", groupsController.deleteById)
    // router.delete("/", groupsController.deleteAll)
  },
  media: {
    cloudinarySignature: `${API_BASE}/cloudinary/signature`,
  },
} as const;

function toURLSearchQueryParams<T>(query?: QueryFilter<T>): string {
  if (ObjectChecker.isEmptyOrNull(query))
    return '';
  // const filter = query.filter ? CommonUtils.toQueryString(query.filter) : {}
  const searchParams = new URLSearchParams();
  searchParams.set("filter", JSON.stringify(query.filter ?? {}));
  searchParams.set("limit", String(query.limit ?? ''));
  searchParams.set("page", String(query.page ?? ''));
  return searchParams.toString();
}